import { useEffect } from 'react';
import { useHeap, usePrivacyCookie, useConsentManager, useRWA } from './';
import { isAmazonHost } from '../utils';

export const useThirdPartyAnalytics = () => {
  const isTrackingAccepted = useConsentManager();
  const isHeapAllowed = usePrivacyCookie('analytics_heap');
  const isRWAAllowed = usePrivacyCookie('analytics_rwa');
  const { load: loadHeap } = useHeap();
  const { load: loadRWA } = useRWA();

  useEffect(() => {
    /**
     * Analytics will be enabled when one of the following use cases occurs (only on r.com):
     * - User has allowed analytics tracking before (we can check this through the privacy cookie)
     * - User clicks the "accept" button in the consent manager banner
     */
    if (!isAmazonHost()) {
      // Load Heap if allowed
      if (isHeapAllowed || isTrackingAccepted) {
        loadHeap();
        loadRWA();
      }
    }
  }, [isHeapAllowed, isRWAAllowed, isTrackingAccepted, loadHeap, loadRWA]);
};
